export const formatPermissionsConst = {
  view: {
    value: "view_format",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu formatu!",
  },
  add: {
    value: "add_format",
    errorMsg: "Użytkownik nie ma uprawnień do dodania formatu!",
  },
  update: {
    value: "change_format",
    errorMsg: "Użytkownik nie ma uprawnień do edycji formatu!",
  },
  delete: {
    value: "delete_format",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania formatu!",
  },
};

export const formatGroupPermissionsConst = {
  view: {
    value: "view_formatgroup",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu grupy formatu!",
  },
  add: {
    value: "add_formatgroup",
    errorMsg: "Użytkownik nie ma uprawnień do dodania grupy formatu!",
  },
  update: {
    value: "change_formatgroup",
    errorMsg: "Użytkownik nie ma uprawnień do edycji grupy formatu!",
  },
  delete: {
    value: "delete_formatgroup",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania grupy formatu!",
  },
};
